import React, { useLayoutEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PrivateRoute({ children }) {
  const { isAuthenticated, isInitializing } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (!isInitializing && !isAuthenticated) {
      navigate('/auth/login', { state: { from: location.pathname }, replace: true });
    }
  }, [isInitializing, isAuthenticated, navigate, location.pathname]);

  if (isInitializing || !isAuthenticated) {
    return null;
  }

  return children;
}
